export default __webpack_public_path__ + "static/media/Gravitationsdrehwaage_Prinzip.20055ba1.png";